import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { SdfButton, SdfFocusPane } from '@waypoint/react-components';

import { setCookie } from '../../util/misc';
import { constants } from '../login/login-comp-constants';
import { constants as panelConstants } from './panel-constants';

import adpLogo from '../../../images/ADP_Logo_Digital.png';
import adpBackground from '../../../images/ADP_Enterprise_background.png';

function SmartBanner({ productId, redirectURL, locale }) {
  const [visible, setVisible] = useState(true);

  const getAppUrl = () => 'https://static.adp.com/static/redbox/qr-code-redirect.html?campaignID=NexoOLPBanner';

  const hideBanner = () => {
    setCookie(panelConstants.OLP_VIEW, constants.MOBILE, false, null);
    setVisible(false);
  };

  const handleOpenApp = () => {
    redirectURL(getAppUrl(), true);
    hideBanner();
  };

  const handleOpenBrowser = () => {
    hideBanner();
  };

  if (!visible) return null;

  return (
    <SdfFocusPane
      id="smartBannerPrompt"
      size="lg"
      visible={ visible }
      closeable={ false }
      hideFooter
      hideAcceptButton
      hideDismissButton
      aria-label="ADP Mobile App Smart Banner"
    >
      <div className="h-full flex flex-col items-center text-center pt-12">
        <img
          src={ adpLogo }
          alt="ADP"
          className="w-28 h-28 object-contain mb-4"
        />

        <div className="mb-4 text-center max-w-sm">
          <div
            className="text-2xl font-bold leading-tight mb-1"
            style={ { color: '#121C4E' } }
          >
            <FormattedMessage
              id="smartbanner.headline.line1"
              defaultMessage="FOR A BETTER EXPERIENCE,"
            />
          </div>
          <div
            className="text-2xl font-bold leading-tight"
            style={ { color: '#C53422' } }
          >
            <FormattedMessage
              id="smartbanner.headline.line2"
              defaultMessage="GET THE ADP MOBILE APP"
            />
          </div>
        </div>

        { /* Illustration */ }
        <img
          src={ adpBackground }
          alt="ADP Mobile App illustration"
          className="w-full max-w-sm md:max-w-md object-contain mb-8"
        />

        <div className="w-full max-w-xs space-y-3">
          <SdfButton
            id="smartBannerOpenApp"
            emphasis="primary"
            size="lg"
            className="w-full"
            onClick={ handleOpenApp }
          >
            <FormattedMessage
              id="smartbanner.open.app"
              defaultMessage="Continue in app"
            />
          </SdfButton>

          <SdfButton
            id="smartBannerOpenBrowser"
            emphasis="secondary"
            size="lg"
            className="w-full"
            onClick={ handleOpenBrowser }
          >
            <FormattedMessage
              id="smartbanner.open.browser"
              defaultMessage="Continue in browser"
            />
          </SdfButton>
        </div>
      </div>
    </SdfFocusPane>
  );
}

SmartBanner.propTypes = {
  productId: PropTypes.string.isRequired,
  redirectURL: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
};

export default SmartBanner;
